import { render } from "./AdminTrackApprovedPayment.vue?vue&type=template&id=0febd44a"
import script from "./AdminTrackApprovedPayment.vue?vue&type=script&lang=js"
export * from "./AdminTrackApprovedPayment.vue?vue&type=script&lang=js"

import "./AdminTrackApprovedPayment.vue?vue&type=style&index=0&id=0febd44a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__